import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {
  AUTH_FLOW_LOGOUT_ROUTES,
  AUTH_FLOW_SDK_ROUTES,
  PhAuthGuard,
  ScopesGuard,
} from '@common/ph-auth';
import { GraphQlGuard } from './graphql.guard';
import { SidebarComponent } from './sidebar/sidebar.component';

const routes: Routes = [
  ...AUTH_FLOW_LOGOUT_ROUTES,
  ...AUTH_FLOW_SDK_ROUTES,
  {
    path: '',
    canActivate: [PhAuthGuard, GraphQlGuard, ScopesGuard],
    data: {
      requiredScopes: ['access:irt'],
    },
    component: SidebarComponent,
    children: [
      {
        path: 'configuration',
        canActivate: [ScopesGuard],
        data: {
          requiredScopes: ['ui:irt:configuration'],
        },
        loadChildren: () =>
          import('./configuration/configuration.module').then(m => m.ConfigurationModule),
      },
      {
        path: 'messages',
        canActivate: [ScopesGuard],
        data: {
          requiredScopes: [],
        },
        loadChildren: () => import('./messages/messages.module').then(m => m.MessagesModule),
      },
      { path: '**', redirectTo: 'messages', pathMatch: 'full' },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
